import request from "@/service";

// 图书列表
export function bookPage(data) {
  return request({
    url: `/resource/book/info/page`,
    method: "post",
    data,
  });
}

// 图书详情
export function bookInfo(uuid) {
  return request({
    url: `/resource/book/info/info/${uuid}`,
    method: "get",
  });
}

// 图书上/下线
export function bookStatus(data) {
  return request({
    url: `/resource/book/info/status`,
    method: "put",
    data,
  });
}

// 图书编辑
export function bookUpdate(data) {
  return request({
    url: `/resource/book/info/update`,
    method: "put",
    data,
  });
}

// 图书删除
export function bookDelete(params) {
  return request({
    url: "/resource/book/info/delete",
    method: "delete",
    data: params,
  });
}

// 图书一键共享
export function bookSharingAll(data) {
  return request({
    url: `/resource/book/info/sharing/all`,
    method: "put",
    data,
  });
}

// 图书共享
export function bookSharing(data) {
  return request({
    url: `/resource/book/info/sharing`,
    method: "put",
    data,
  });
}

// 共享管理列表
export function bookSharingPage(params) {
  return request({
    url: `/resource/book/info/share/page`,
    method: "get",
    params,
  });
}

// 图书取消共享
export function bookCancel(data) {
  return request({
    url: `/resource/book/info/cancel`,
    method: "put",
    data,
  });
}

// 图书恢复共享
export function bookRecover(data) {
  return request({
    url: `/resource/book/info/recover`,
    method: "put",
    data,
  });
}

// 图书分类
export function bookCategory(data) {
  return request({
    url: `/resource/book/info/category`,
    method: "put",
    data,
  });
}

// 导入图书
export function importBook(params) {
  return request({
    url: `/resource/book/info/import`,
    method: "post",
    headers: {
      "Content-Type":
        "multipart/foresource-data; boundary=----WebKitForesourceBoundaryyJzVStTyqSc9B1Ut",
    },
    data: params,
  });
}

// 图书列表
export function listBook(params) {
  return request({
    url: `/resource/book/info/findBookList`,
    method: "get",
    params,
  });
}

// 图书章节列表
export function chapterList(uuid) {
  return request({
    url: `/resource/book/info/chapterList/${uuid}`,
    method: "get",
  });
}

//图书预览
export function bookPreview(uuid) {
  return request({
    url: `/resource/book/info/preview/${uuid}`,
    method: "get",
  });
}

//图书统计-概况-jcc
export function bookBasic(params) {
  return request({
    url: `/resource/book/info/statistic/basic`,
    method: "get",
    params,
  });
}

// 分类统计
export function statisticCategory(params) {
  return request({
    url: `/resource/book/info/statistic/category`,
    method: "get",
    params,
  });
}

// 学习明细
export function statisticLearn(data) {
  return request({
    url: `/resource/book/info/statistic/learn`,
    method: "post",
    data,
  });
}

// 获取图书列表
export function getBookByName(params) {
  return request({
    url: `/resource/book/info/namePage`,
    method: "get",
    params,
  });
}

/* 图书统计-导出-wangchao */
export function exportBookStatisticInfo(data) {
  return request({
    url: `/resource/book/info/statistic/exportLearn`,
    method: "post",
    responseType: "blob",
    headers: {
      Accept: "application/json, text/plain, */*, application/octet-stream",
      "Content-Type": "application/json;charset=UTF-8",
    },
    data,
  });
}

// 修改图书展示终端
export function updateBookDisplay(data) {
  return request({
    url: `/resource/book/info/updateBookDisplay`,
    method: "post",
    data,
  });
}
